import React, { useState, useContext } from "react";

import classNames from "classnames";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import Icon from "../../Icon/Icon";
import Markdown from "../../styles/Markdown";

const Wrapper = styled.div`
  background-color: ${(props) => props.backgroundColour};
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  ${(props) => props.dynamicStyles}
`;

const Component = styled.div`
  margin: 0 auto;
  padding: 0 1rem;
`;

const Header = styled.div`
  background-color: ${(props) => props.headerColour};
  color: black;
  cursor: pointer;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: 10px; // Maintain top border radius
  border-top-right-radius: 10px;
  border-bottom-right-radius: ${(props) =>
    props.isOpen ? "0" : "10px"}; // Adjust as necessary
  border-bottom-left-radius: ${(props) =>
    props.isOpen ? "0" : "10px"}; // Adjust as necessary
  transition: background-color 0.2s ease-out;
  transition: border-bottom-left-radius 1s ease-out;
  transition: border-bottom-right-radius 1s ease-out;
  box-shadow: #c5c2c2 1px 2px 2px 0px;
  }
`;

const BodyWrapper = styled.div`
  max-height: ${(props) =>
    props.isOpen ? "1000px" : "0px"}; // Adjust as necessary
  transition: max-height 0.25s ease-out;
  overflow: hidden;
  border-bottom-left-radius: 10px; // Border radius for the bottom corners
  border-bottom-right-radius: 10px;
  box-shadow: #c5c2c2 1px 2px 2px 0px;
`;

const Body = styled.div`
  padding: 1rem;
  background-color: ${(props) => props.bodyColour};
`;

const IconWrapper = styled.span`
  transition: transform 0.2s ease-out;
  display: flex; // Center the icon vertically and horizontally
  align-items: center;
  justify-content: center;
  fill: black;
`;

function FAQAccordion() {
  const {
    backgroundColour = "#fff",
    headertext = "Refer a friend",
    bodyText = "Create Link",
    headerColour = "#fff",
    bodyColour = "#fff",
    fullWidth = false,
    componentClassName = "",
    CSS = "",
  } = useContext(ComponentContext);

  const rowClassName = classNames(
    { row: !fullWidth },
    componentClassName,
    "faq-accordion"
  );

  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Wrapper
      backgroundColour={backgroundColour}
      dynamicStyles={CSS}
      className={rowClassName}
    >
      <Component>
        <Header
          onClick={toggleAccordion}
          headerColour={headerColour}
          isOpen={isOpen}
          className="faq-accordion-header"
        >
          <Markdown>{headertext}</Markdown>
          <IconWrapper isOpen={isOpen}>
            <Icon
              icon={isOpen ? "chevronUp" : "chevronDown"}
              size={20}
              color="black"
            />
          </IconWrapper>
        </Header>
        <BodyWrapper isOpen={isOpen} className="faq-accordion-body-wrapper">
          <Body bodyColour={bodyColour} className="faq-accordion-body">
            <Markdown>{bodyText}</Markdown>
          </Body>
        </BodyWrapper>
      </Component>
    </Wrapper>
  );
}

export default FAQAccordion;
